export function getOrgInitials(organization) {
  var orgInitials = organization.name.match(/\b(\w)/g).join('')
  orgInitials = orgInitials.length > 2 ? orgInitials.substr(0, 2) : orgInitials
  return orgInitials
}



// WEBPACK FOOTER //
// ./src/utils/organization.js